<script>
    import {
        previewImage,
        showError,
    } from "../../../Utils/utilFunctions.svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    import { Loader } from "../../../Components/Common/index.svelte";

    export let userAccountId,
        accountName,
        disabled = false,
        avatarType;

    let accountAvatar = {},
        isReplacing = false,
        isAvatarLoading = false,
        avatarFileInput;

    $: if (userAccountId && avatarType) loadAccountAvatar();

    const loadAccountAvatar = () => {
        apiMethods.getMethod
            .getAccountAvatarWithType(userAccountId, avatarType)
            .then((res) => _handleAccountAvatar(res.results))
            .catch((err) => showError(err));
    };

    const afterAccountAvatarUpload = (res) => {
        isAvatarLoading = false;
        if (res.id) accountAvatar.id = res.id;
        else if (res.error) showError(res.error);
    };

    const onAvatarFileChange = (e) => {
        if (isAvatarLoading) return;

        const file = e.target.files[0];

        if (!file) return;

        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = async (e) => {
            accountAvatar = {
                content: e.target.result,
                id: accountAvatar.id ?? null,
            };

            await updateAvatar();
        };
    };

    const updateAvatar = async () => {
        isAvatarLoading = true;

        if (isReplacing) {
            await apiMethods.putMethod
                .updateAvatar({
                    id: accountAvatar.id,
                    accountId: userAccountId,
                    type: avatarType,
                    content: accountAvatar.content.split(",")[1],
                })
                .then((res) => {
                    afterAccountAvatarUpload(res);
                })
                .catch((err) => {
                    showError(err);
                    isAvatarLoading = false;
                });
        } else if (avatarType == 2)
            await apiMethods.postMethod
                .createAccountAvatar({
                    accountId: userAccountId,
                    content: accountAvatar.content.split(",")[1],
                })
                .then((res) => {
                    afterAccountAvatarUpload(res);
                })
                .catch((err) => {
                    showError(err);
                    isAvatarLoading = false;
                });
        else if (avatarType == 3)
            await apiMethods.postMethod
                .createAccountAvatarForPatient({
                    accountId: userAccountId,
                    content: accountAvatar.content.split(",")[1],
                })
                .then((res) => {
                    afterAccountAvatarUpload(res);
                })
                .catch((err) => {
                    showError(err);
                    isAvatarLoading = false;
                });
    };

    const _handleAccountAvatar = (arr = []) => {
        isAvatarLoading = false;
        if (!arr || !arr.length) return (accountAvatar = {});

        const len = arr.length;

        accountAvatar = {
            content: `data:image/jpg;base64,${arr[len - 1].content}`,
            id: arr[len - 1].id,
        };
    };

    const previewAvatar = () => {
        if (accountAvatar.content) {
            previewImage({
                previewTitle: "Preview Avatar",
                imageContent: accountAvatar.content,
                alt: "Avatar",
            });
        }
    };

    const deleteAccountAvatar = async () => {
        if (!accountAvatar.id) return;
        isAvatarLoading = true;

        await apiMethods.deleteMethod
            .deleteAccountAvatar(accountAvatar.id)
            .then((res) => {
                if (res.error) showError(res.error);
                else
                    apiMethods.getMethod
                        .getAccountAvatar(userAccountId)
                        .then((res) => _handleAccountAvatar(res.results))
                        .catch((err) => showError(err));
            })
            .catch((err) => showError(err));

        isAvatarLoading = false;
    };

    const startReplaceAccountAvatar = () => {
        isReplacing = true;
        avatarFileInput.click();
    };

    const uploadAccountAvatar = () => {
        isReplacing = false;
        avatarFileInput.click();
    };
</script>

<div class="flex flex-1 items-end p-2">
    <div class="avatar cursor-pointer pl-2">
        {#if isAvatarLoading}
            <div class="avatar placeholder cursor-not-allowed">
                <div
                    class="bg-secondary text-secondary-content rounded-full w-16"
                >
                    <Loader />
                </div>
            </div>
        {:else if accountAvatar.content}
            <div
                class="w-16 rounded-full ring ring-secondary ring-offset-base-100 ring-offset-2"
                on:click={previewAvatar}
            >
                <img src={accountAvatar.content} alt="" />
            </div>
        {:else if !disabled}
            <button
                class="btn btn-sencodary btn-sm gap-x-2"
                on:click|preventDefault={uploadAccountAvatar}
                {disabled}
            >
                <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                Click To Upload
            </button>
        {/if}
    </div>
    {#if accountAvatar.content && !disabled}
        <div class="tooltip" data-tip="Preview">
            <button
                class="btn btn-ghost btn-circle btn-sm"
                on:click|preventDefault={previewAvatar}
                {disabled}
            >
                <i class="fa-solid fa-magnifying-glass"></i>
            </button>
        </div>

        <div class="tooltip" data-tip="Upload">
            <button
                class="btn btn-ghost btn-circle btn-sm"
                on:click|preventDefault={startReplaceAccountAvatar}
                {disabled}
            >
                <i class="fa fa-cloud-upload" aria-hidden="true"></i>
            </button>
        </div>

        <div class="tooltip" data-tip="Delete">
            <button
                class="btn btn-ghost btn-circle btn-sm"
                on:click|preventDefault={deleteAccountAvatar}
                {disabled}
            >
                <i class="deleteIcon fa-solid fa-trash"></i>
            </button>
        </div>
    {/if}
    <input
        type="file"
        accept=".jpg, .jpeg, .png"
        style="display: none;"
        id="avatarFileInput"
        {disabled}
        on:change={onAvatarFileChange}
        bind:this={avatarFileInput}
    />
</div>
